// node modules
import React from 'react';
import { observer } from 'mobx-react';
// store
import { useStore } from 'modules/Stores';
// ui library
import { LoadingBlock, View } from '@upstox/upstox-ui';
// styles
import * as css from './styles';

const OptionChainCell: React.FC = ({ children }) => {
  const { loading } = useStore('OptionChainStore');

  return loading ? (
    <View css={css.loaderContainer} flex>
      <LoadingBlock height={14} width={40} />
    </View>
  ) : (
    <React.Fragment>{children}</React.Fragment>
  );
};

export default observer(OptionChainCell);
